import React from "react";
import { Line, Card } from "ktm-ui";
import ReactMoment from "react-moment";

interface IdsEmployee {
  id: string;
  policyId: string;
  policyBenefitId: string;
  action: string;
  note: string;
  updatedAt: string;
  UpdatedBy: string;
  createdAt: string;
  createdBy: string;
  author: string;
  comment: string;
}

interface State {
  policyLogs: IdsEmployee[];
  isHistoryVisible: boolean;
  comments: { [key: number]: string };
}

export default class EmployeeLogs extends React.Component<
  { employee_id: string },
  State
> {
  state: State = {
    policyLogs: [],
    isHistoryVisible: true,
    comments: {},
  };

  // Submit Comments on 'Enter' Key
  handleKeyDown = (
    event: React.KeyboardEvent<HTMLInputElement>,
    log_id: string,
    comment: string
  ) => {
    if (event.key === "Enter") {
      this.submitComments(log_id, comment); // Submit only when 'Enter' is pressed
    }
  };

  // Handle Comment Change and Detect 'Enter' Key Press
  handleCommentChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number,
    log_id: string
  ) => {
    const { value } = event.target;

    this.setState((prevState) => ({
      comments: {
        ...prevState.comments,
        [index]: value, // Track comments by row index
      },
    }));
  };

  async submitComments(log_id: string, comment: string) {
    const policyLogs = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        Id: log_id,
        Comment: comment,
      }),
    };
    await fetch("/api/PlanAdmin/updatepolicylogscomments", policyLogs).catch(
      (error) => console.error("Error submitting comments:", error)
    );
  }

  componentDidMount(): void {
    this.getPolicyLog();
  }

  render() {
    const historyLogTable = (
      <div className="history-content">
        <table className="table">
          <thead>
            <tr>
              <th style={{ width: "250px" }}>Action</th>
              <th>Details</th>
              <th style={{ width: "200px" }}>Timestamp</th>
              <th style={{ width: "200px" }}>Modified By</th>
              <th style={{ width: "350px" }}>Comment</th>
            </tr>
          </thead>
          <tbody>
            {this.state.policyLogs.map((data, i) => (
              <tr key={i}>
                <td>{data.action}</td>
                <td>{data.note}</td>
                <td>
                  <ReactMoment format="YYYY-MM-DD HH:mm:ss">
                    {data.updatedAt}
                  </ReactMoment>
                </td>
                <td>{data.author}</td>
                <td>
                  <input
                    type="text"
                    value={
                      this.state.comments[i] !== undefined
                        ? this.state.comments[i]
                        : data.comment || ""
                    }
                    onChange={(e) => this.handleCommentChange(e, i, data.id)}
                    onKeyDown={(e) =>
                      this.handleKeyDown(
                        e,
                        data.id,
                        this.state.comments[i] || data.comment || ""
                      )
                    }
                    placeholder="Add comment..."
                    className="comment-input"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );

    return (
      <div style={{ marginTop: 15 }}>
        <Card
          label="History logs"
          actions={
            <button
              onClick={this.toggleHistory}
              className={`toggle-button ${
                this.state.isHistoryVisible ? "open" : ""
              }`}
            >
              <span className="arrow"></span>
            </button>
          }
        >
          {this.state.isHistoryVisible && this.state.policyLogs && (
            <Line>{historyLogTable}</Line>
          )}
        </Card>
      </div>
    );
  }

  toggleHistory = () => {
    this.setState({ isHistoryVisible: !this.state.isHistoryVisible });
  };

  getPolicyLog = () => {
    fetch("/api/PlanAdmin/getemployeelogs?id=" + this.props.employee_id, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          policyLogs: data,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };
}
